import { Tooltip as MuiTooltip } from '@mui/material'
import { styled } from '@mui/system'
import { memo, useCallback, useRef, useState } from 'react'

type EllipsisTextProps = {
  children: string
  className?: string
}

export const EllipsisText = memo(
  ({ children, className }: EllipsisTextProps) => {
    const ref = useRef<HTMLSpanElement>(null)
    const [open, setOpen] = useState(false)

    const handleMouseEnter = useCallback(() => {
      if (ref.current && ref.current.scrollWidth > ref.current.clientWidth) {
        setOpen(true)
      }
    }, [])

    const handleMouseLeave = useCallback(() => {
      setOpen(false)
    }, [])

    return (
      <MuiTooltip
        title={children}
        open={open}
        disableHoverListener={true}
        disableFocusListener={true}
        disableTouchListener={true}
      >
        <EllipsisSpan
          ref={ref}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          className={className}
        >
          {children}
        </EllipsisSpan>
      </MuiTooltip>
    )
  }
)

const EllipsisSpan = styled('span')({
  display: 'block',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
})
